export default "__VITE_ASSET__CZ8j8I0c__"